import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { useWizardStepContext } from 'v2/components/WizardModal';
import { HOME_PATH } from 'v2/paths';

const STEP_INDEX = 3;

const AlmostReadyStep = () => {
  const { setFooterContent, steps } = useWizardStepContext();
  const navigate = useNavigate();
  const onGoToAtlasWebPortalButtonClick = () => navigate(HOME_PATH);

  React.useLayoutEffect(() => {
    setFooterContent(
      STEP_INDEX,
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, gap: 2 }}>
        <Button
          key="device-group-name-step-submit"
          id="go-to-atlas-portal-button"
          variant="contained"
          color="primary"
          onClick={onGoToAtlasWebPortalButtonClick}
        >
          Go to ATLAS web portal
        </Button>
      </Box>
    );
  }, [setFooterContent, steps]);

  return (
    <Stack flexDirection="column" gap={1}>
      <Typography variant="h4" color="textPrimary">
        Almost ready
      </Typography>
      <Divider />
      <Typography variant="body1" color="textPrimary">
        ATLAS Enterprise apps have been installed and users are being synchronized. Once user groups have been
        synchronized, you are able to login at the ATLAS Web portal. This process can take up to an hour, depending on
        the amount of users that needs to be synced.
      </Typography>
      <Divider />
    </Stack>
  );
};
export default AlmostReadyStep;
